import React, { useEffect, useRef, useState } from 'react';
import CustomVideo from '../CustomVideo';
import '../../styles/Sections.scss';
import Screener from '../Screener';
import { useAuthContext } from '../../context/authContext';
import { useDispatch, useSelector, connect } from 'react-redux';
import {
  hideKnowledgeCheck,
  cancelScreener,
  resetCurrentScreener,
  fetchKnowledgeCheckByKCid,
} from '../../redux/actions/knowledgeCheckActions';
import { getUser } from '../../services/localStorage';
import { onSelectCurrentVideo } from '../../redux/actions/videoActions';
import {
  updateModuleSectionVideoProgress,
  getTotalVideoProgresses,
} from '../../redux/actions/sectionActions';
import { BASE_API_URL } from '../../constants/constants';
import { requestGetApi } from '../../services/api/api';
import Favorite from '../Favorite';
import { Col, Jumbotron, Modal, Toast } from 'react-bootstrap';
import RatingReview from '../RatingReview';

import { createRating } from '../../redux/actions/sectionActions';


import {
  getScreenerStatus,
  dismissScreener,
  getScreener,
  getKnowledgeCheck,
} from '../../redux/actions/screenersActions';

const percentages = [
  0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7,
  0.75, 0.8, 0.85, 0.9, 0.95, 0.97, 1,
];
const SectionHome = ({ section, stopVideo, fromFavorites }) => {
  const dispatch = useDispatch();
  const currentUser = getUser();

  const cancel = useSelector((state) => state.knowledgeCheck.cancel);

  const { openFavoriteSection } = useSelector((state) => state.favorite);
  const { showKnowledgeChecks, knowledgeChecks } = useSelector(
    (state) => state.knowledgeCheck
  );
  const { currentVideo } = useSelector((state) => state.video);
  const { currentScreener } = useSelector((state) => state.knowledgeCheck);
  const { currentModule } = useSelector((state) => state.module);
  const { favoriteVideos } = useSelector((state) => state.favorite);
  const { currentSection, currentFavoriteVideoOff } = useSelector(
    (state) => state.section
  );
  const { selectedFavoriteVideo } = useSelector((state) => state.favorite);

  const {
    state: { user },
  } = useAuthContext();

  const [videos, setVideos] = useState([]);
  const [isStart, setIsStart] = useState(false);
  const [isSurveyStart, setIsSurveyStart] = useState(false);
  const [videoProgresses, setVideoProgresses] = useState({});
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState(0);
  const [screeners, setScreeners] = useState([]);
  const unmountRef = useRef([]);

  const [shouldRenderVideos, setShouldRenderVideos] = useState(false);

  const [modal, setModal] = useState(false);

  const [initialAllVideosCompleted, setInitialAllVideosCompleted] =
    useState(false);

  const [showRatingWarning, setshowRatingWarning] = useState(false);

  const [screener, setScreener] = useState(0);

  const [showScreenerModal, setShowScreenerModal] = useState(false);
  const [eventScreener, setEventScreener] = useState(null);
  const [eventKnowledgeChecks, setEventKnowledgeChecks] = useState([]);

  useEffect(async () => {
    setCurrentPlayingVideo(0);
  }, [stopVideo]);

  useEffect(() => {
    if (section) {
      setVideos(section.items);
      requestGetApi(`${BASE_API_URL}/screeners`)
        .then(async (data) => {
          let screeners = [];
          for (let s of data.screeners) {
            if (s.module_section_id == section.id) {
              // add screeners that belongs to section
              screeners.push(s);
            }
          }
          setScreeners(screeners);
        })
        .catch((e) => console.error(e));
    }
  }, [section]);

  function renderScreener(sItem) {
    setIsStart(!isStart);

    const timeout = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 500);

    setScreener(sItem);

    dispatch(fetchKnowledgeCheckByKCid(sItem.knowledge_check_id));
    hideUnCollapsedItems(true);
  }

  // *********************
  // get favorite videos
  useEffect(() => {
    if (fromFavorites && favoriteVideos && favoriteVideos.length) {
      setVideos([...favoriteVideos]);
      const filteredSections = [];
      for (const fv of favoriteVideos) {
        filteredSections.push(fv.module_section_id);
      }
      requestGetApi(`${BASE_API_URL}/screeners`)
        .then(async (data) => {
          let screeners = new Map();
          for (let s of data.screeners) {
            if (filteredSections.includes(s.module_section_id)) {
              // add screener that belong to section
              screeners.set(s.screener_type, s);
            }
          }
          setScreeners(Array.from(screeners, ([name, value]) => value));
        })
        .catch((e) => console.error(e));
    }
  }, [fromFavorites, favoriteVideos]);

  useEffect(() => {
    if (selectedFavoriteVideo) {
      // scroll to video when favorite section is open
      setTimeout(() => {
        scrollToVideo(selectedFavoriteVideo);
      }, 200);
    }
  }, [selectedFavoriteVideo]);

  // ********************************
  // get videos from currenSection
  useEffect(() => {
    let temp = {};

    if (
      !fromFavorites &&
      currentSection &&
      currentSection.items &&
      currentSection.items.length
    ) {
      currentSection.items.forEach((video) => {
        let progresses =
          (video.progresses.length && video.progresses[0].progress) || 0;
        let videoProgress = percentages
          .filter((percentage) => progresses / video.duration <= percentage)
          .map((percentage) => percentage * video.duration);

        if (!temp[video.id]) temp[video.id] = [];
        temp[video.id] = videoProgress;
      });

      setVideoProgresses({ ...temp });
    }

    // eslint-disable-next-line
  }, [currentSection]);

  useEffect(() => {
    hideUnCollapsedItems(false);

    // when component unmount, send the played value to the API
    return () => {
      if (unmountRef.current) {
        unmountRef.current.forEach((e) => sendVideoProgress(e));

        unmountRef.current = [];
      }
    };

    // eslint-disable-next-line
  }, [currentModule]);

  useEffect(() => {
    if (showKnowledgeChecks) {
      dispatch(hideKnowledgeCheck());
    }
    // eslint-disable-next-line
  }, [currentSection, currentModule, currentVideo, currentScreener]);

  const scrollToVideo = (video) => {
    if (!video) return;

    const element = document.getElementById(`video-${video.id}`);
    if (!element) return;

    setTimeout(() => {
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 200);
  };

  const sendVideoProgress = (video) => {
    if (video.playedSeconds > video.progresses) {
      const videoDuration = +video.duration;
      const percentToDone = videoDuration > 1200 ? 0.97 : 0.95;
      const almostDone = video.playedSeconds >= videoDuration * percentToDone;
      const module_section_videos_progress_params = {
        progress: almostDone ? videoDuration : video.playedSeconds,
        module_section_video_id: video.video,
        status: 'in_progress',
        user_id: user.id,
      };

      dispatch(
        updateModuleSectionVideoProgress(module_section_videos_progress_params)
      );
    }
  };

  const hideUnCollapsedItems = (hide = false) => {
    if (!hide) {
      try {
        const currentModuleAccordion = document.getElementById(
          `kc-ac-${currentModule?.id}`
        );
        if (!currentModuleAccordion) return;
        const unselectedItems =
          currentModuleAccordion.querySelectorAll(`.mt-5.card`);
        unselectedItems.forEach((card) => {
          // card.style.removeProperty('border');
          card.classList.remove('d-none');
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        const currentModuleAccordion = document.getElementById(
          `kc-ac-${currentModule?.id}`
        );
        const unselectedItems =
          currentModuleAccordion.querySelectorAll(`.mt-5.card`);
        if (!currentModuleAccordion) return;

        unselectedItems.forEach((card) => {
          if (!!!card.querySelector('.show')) {
            // card.style.setProperty('border', 'none', 'important');
            card.classList.add('d-none');
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        });
      } catch (e) {
        console.log(e);
      }
    }
  };

  let progressRequestWaiting = false;
  let lastProgress = null;
  let lastVideo = null;

  const onProgress = (progress, video) => {
    lastProgress = progress;
    lastVideo = video;

    if (!progressRequestWaiting) {
      progressRequestWaiting = true;
      setTimeout(function () {
        const localProgress = lastProgress;
        const localVideo = lastVideo;
        if (localProgress) {
          // this update progress and save in db
          let index = unmountRef.current.findIndex(
            (e) => e.video === localVideo.id
          );

          let objectVideo = {
            video: localVideo.id,
            duration: localVideo.duration,
            progresses:
              (localVideo.progresses.length &&
                localVideo.progresses[0].progress) ||
              0,
            playedSeconds: localProgress.playedSeconds,
          };

          if (index === -1) unmountRef.current.push(objectVideo);
          else
            unmountRef.current[index].playedSeconds =
              localProgress.playedSeconds;

          if (
            videoProgresses[localVideo.id] &&
            videoProgresses[localVideo.id].some(
              (percentage) => percentage < localProgress.playedSeconds
            )
          ) {
            let temp = videoProgresses[localVideo.id].filter(
              (percentage) => percentage < localProgress.playedSeconds
            );
            temp = videoProgresses[localVideo.id].filter(
              (percentage) => !temp.some((e) => e === percentage)
            );

            sendVideoProgress(objectVideo);

            videoProgresses[localVideo.id] = [...temp];
            setVideoProgresses({ ...videoProgresses });
          }
        }
        progressRequestWaiting = false;
      }, 1000);
    }
  };

  const sortItem = (a, b) => {
    if (a.order < b.order) return -1;
    if (a.order > b.order) return 1;
    return 0;
  };

  const goBack = () => {
    setIsStart(false);
    dispatch(hideKnowledgeCheck());
    setCurrentPlayingVideo(0);

    hideUnCollapsedItems(false);
    setIsSurveyStart(false);
  };

  useEffect(() => {
    setShouldRenderVideos(
      fromFavorites
        ? true
        : currentSection && videos && videos.length
        ? videos[0].module_section_id === currentSection.id
        : false
    );
  }, [fromFavorites, currentSection, videos]);

  if (!currentUser.can_view_videos)
    return (
      <>
        <p className="m-0 text-danger">
          Please contact your organization’s leadership
        </p>
      </>
    );


  const areAllModuleVideosCompleted = async () => {
    try {
      const response = await requestGetApi(
        `${BASE_API_URL}/module_sections?course_module_id=${currentModule.id}`
      );
      //console.log(response.module_sections);

      // Check if the response has 'module_sections' property and it is an array
      if (response.module_sections && Array.isArray(response.module_sections)) {
        // Iterate through each module section
        for (const section of response.module_sections) {
          // Check if the section has items (videos)
          if (section.items && Array.isArray(section.items)) {
            // Iterate through each video in the section
            for (const video of section.items) {
              // Check if the video has progresses
              if (video.progresses && Array.isArray(video.progresses)) {
                // Check if any progress has status other than "completed"
                const isVideoCompleted = video.progresses.some(
                  (progress) => progress.status === 'completed'
                );

                // If any video is not completed, return false
                if (!isVideoCompleted) {
                  return false;
                }
              } else {
                // If the video has no progresses, consider it not completed
                return false;
              }
            }
          }
        }

        // If all videos are completed, return true
        return true;
      } else {
        console.error('Invalid response format');
        return false; // or handle the error accordingly
      }
    } catch (error) {
      console.error('Error fetching module sections:', error);
      return false; // or handle the error accordingly
    }
  };

  const closeModal = () => {
    setModal(!modal);
  };

  const submitRating = () => {
    if (rating === 0) {
      setshowRatingWarning(true);
      return;
    }

    // Dispatch createRating action with relevant parameters
    const moduleId = currentModule.id;
    const sectionId = currentSection.id;
    const videoId = currentVideo.id;
    dispatch(createRating(moduleId, sectionId, videoId, rating));

    setModal(!modal);
  };

  const [rating, setRating] = useState(0);

  const onStarClick = (nextValue, prevValue, name) => {
    setRating(nextValue);
  };

  useEffect(() => {
    if (cancel) {
      // Perform action screener cancelled
      if (currentScreener != undefined) {
        dispatch(resetCurrentScreener());
        setIsStart(false);
        // Optionally reset the cancel state
      }

      dispatch(cancelScreener(false));
    }
  }, [cancel, dispatch]);

  const fetchScreenerStatus = async () => {
    if (user) {
      for (let user_ebs of user.event_based_screeners) {
        if (user_ebs.event_type == 2) {
          await checkContentTimeScreenerEventStatus(user_ebs);
          break;
        }
      }
    }
  };

  const checkContentTimeScreenerEventStatus = async (user_ebs) => {
    try {
      const contentTime = await getTotalVideoProgresses();

      // Check if content time exceed the event based q threshold
      if (
        contentTimeExceedThreshold(
          contentTime.total_video_progresses,
          user_ebs.event_params
        )
      ) {
        const screenerEventStatus = await getScreenerStatus(
          user_ebs.id,
          user.id
        );

        const screener = await getScreener(user_ebs.id);
        setEventScreener(screener);

        // check for uncompleted event
        if (
          screenerEventStatus.completed == false &&
          screenerEventStatus.dismissed < screener.max_dismissals
        ) {
          const kc = await getKnowledgeCheck(screener.knowledge_check_id);
          setEventKnowledgeChecks([kc]);
          setShowScreenerModal(true);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  function contentTimeExceedThreshold(contentTimeInSeconds, thresholdInHours) {
    // Convert threshold from hours to seconds for comparison
    const thresholdInSeconds = thresholdInHours * 3600;

    return contentTimeInSeconds > thresholdInSeconds;
  }

  const goBackEventScreener = async () => {
    try {
      const screenerEventStatus = await dismissScreener(
        eventScreener.id,
        user.id
      );
    } catch (err) {
      console.log(err.message);
    }

    setEventScreener(null);
    setEventKnowledgeChecks(null);
    setShowScreenerModal(false);
  };

  return (
    <>
      {eventScreener ? (
        <Modal size="lg" show={showScreenerModal} fullscreen={'true'}>
          <Modal.Body>
            <Screener
              content={eventKnowledgeChecks}
              screener={eventScreener}
              goBack={goBackEventScreener}
            />
          </Modal.Body>
        </Modal>
      ) : (
        ''
      )}

      {!isStart && !isSurveyStart && shouldRenderVideos ? (
        <div
          className="section-home-container"
          onClick={(event) => {
            // avoid onClick event in Accordion been executed
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          {videos.sort(sortItem).map((video, index) => {
            return (
              ![].includes(video.id) && (
                <section
                  id={`section-video-${video.id}`}
                  key={index}
                  aria-label={video.title + ' video section'}
                >
                  <div id={`video-${video.id}`} className={`mb-4`}>
                    <div
                      className={`video-favorite-container ${
                        openFavoriteSection &&
                        currentFavoriteVideoOff === video.id
                          ? 'opacity-0'
                          : ''
                      }`}
                    >
                      <CustomVideo
                        video={video}
                        playing={
                          currentPlayingVideo === 0
                            ? false
                            : currentPlayingVideo === video.id
                        }
                        onScreener={(screener) => {
                          setScreener(screener);
                          setIsStart(!isStart);

                          const timeout = setTimeout(() => {
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            });
                          }, 500);

                          dispatch(
                            fetchKnowledgeCheckByKCid(
                              screener.knowledge_check_id
                            )
                          );
                          hideUnCollapsedItems(true);
                        }}
                        onPlay={(videoId) => {
                          const fetchAllVideosCompletion = async () => {
                            const completionStatus =
                              await areAllModuleVideosCompleted();
                            setInitialAllVideosCompleted(completionStatus);
                          };

                          fetchAllVideosCompletion();

                          setCurrentPlayingVideo(videoId);
                          dispatch(onSelectCurrentVideo({ ...video }));
                        }}
                        onProgress={(progress) =>
                          currentPlayingVideo === video.id
                            ? onProgress(progress, video)
                            : {}
                        }
                        onEnded={() => {
                          setTimeout(async () => {
                            await fetchScreenerStatus();

                            const response = await requestGetApi(
                              `${BASE_API_URL}/module_sections?course_module_id=${currentModule.id}`
                            );

                            const allVideosCompleted =
                              await areAllModuleVideosCompleted();
                            if (
                              initialAllVideosCompleted == false &&
                              allVideosCompleted
                            ) {
                              setInitialAllVideosCompleted(true);
                              setRating(0);
                              // show the modal
                              setModal(true);
                            }
                          }, 2000);
                        }}
                      />
                    </div>
                  </div>
                </section>
              )
            );
          })}

          {screeners.length > 0 && (currentSection || fromFavorites) ? (
            <div
              id={
                'screenersContainer' +
                (currentSection ? currentSection.id : 'Favorites')
              }
            >
              {screeners.map(
                (sItem) =>
                  ((currentSection && !fromFavorites) ||
                    (fromFavorites && sItem.video?.user_favorite)) && (
                    <section id={'screener' + sItem.id} key={sItem.id}>
                      <div className="mt-3">
                        <h3 className="text-color-gray font-24 font-poppins fw-300">
                          <a
                            href="#"
                            onClick={(e) => {
                              renderScreener(sItem);
                            }}
                            id={'screenerHeader' + sItem.id}
                            className="text-color-gray font-24 font-poppins fw-300"
                            style={{ textDecoration: 'none' }}
                            aria-label={'Screener'}
                            aria-expanded={true}
                            role="button"
                          >
                            {
                              // Screener Banner title
                              sItem.knowledge_check_name
                            }
                          </a>
                        </h3>
                      </div>
                      <div className="mt-3">
                        <img
                          src={sItem.knowledge_check_banner_url}
                          onClick={(e) => {
                            renderScreener(sItem);
                          }}
                          width="100%"
                          height="auto"
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      <div className="mt-3">
                        <div className="video-description-container">
                          <div className="d-flex flex-wrap justify-content-between align-items-start align-items-sm-center">
                            <div className="ml-2">
                              <div className="d-flex align-items-center justify-content-start">
                                <div className="mr-3 cursor-pointer">
                                  <Favorite
                                    video={sItem}
                                    user_favorite={sItem.user_favorite}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="video-description">
                            <div className="description">
                              {sItem.knowledge_check_description}
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        // OR
        ''
      )}

      {isStart ? (
        <Screener
          section={currentSection}
          content={knowledgeChecks}
          screener={screener}
          goBack={goBack}
        />
      ) : (
        // OR
        ''
      )}

      {
        <Modal show={modal} fullscreen={'true'}>
          <Modal.Body>
            <Jumbotron
              className="text-center mb-1 mt-0"
              style={{
                borderRadius: '5px',
                backgroundColor: '#e8f6fc',
                height: '320px',
                paddingTop: '30px',
              }}
            >
              <h1
                className={`text-center`}
                style={{
                  fontSize: '24px',
                  color: 'rgb(105, 105, 105)',
                  fontFamily: 'Poppins',
                }}
              >
                Congratulations!
              </h1>
              <br></br>
              <p
                className={`text-center`}
                style={{
                  fontSize: '14px',
                  color: 'rgb(105, 105, 105)',
                  fontFamily: 'Poppins',
                }}
              >
                You have completed the <strong>{currentModule?.name}</strong>{' '}
                module. Your certificate will be available shortly under "My
                Certificates" in your account profile.
              </p>
              <p
                className={`text-center`}
                style={{
                  fontSize: '14px',
                  color: 'rgb(105, 105, 105)',
                  fontFamily: 'Poppins',
                }}
              >
                Please take a moment to share your feedback on this module by
                rating it 1-5 stars.
              </p>
              <div className={`text-center`} style={{ fontSize: 30 }}>
                <RatingReview rating={rating} setRating={onStarClick} />
              </div>

              {showRatingWarning ? (
                <p
                  className={`text-center`}
                  style={{ fontSize: '14px', color: 'red' }}
                >
                  Please select a rating
                </p>
              ) : null}
            </Jumbotron>
            <button
              className={`custom-button-default w-100 d-flex justify-content-center text-white`}
              onClick={submitRating}
              style={{ fontSize: '16px', fontWeight: 600 }}
            >
              <label
                style={{ fontSize: '16px', fontWeight: 600, cursor: 'pointer' }}
              >
                Submit Rating
              </label>
            </button>
            <p className={`text-right  mt-2 mb-0 mr-1`}>
              <a href="#" className="gray-link" onClick={closeModal}>
                Skip
              </a>
            </p>
          </Modal.Body>
        </Modal>
      }
    </>
  );
};

// Map state to props
const mapStateToProps = (state) => ({
  cancel: state.knowledgeCheck.cancel,
});

// Map dispatch to props
const mapDispatchToProps = {
  cancelScreener,
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionHome);
